export default "__VITE_ASSET__BZy0hrYu__"